// extracted by mini-css-extract-plugin
export default {"meta":"PhoneCard_meta__9scYE"};